import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { DSM3ModalService } from '@eredes/dsm3';

import { IAttachment } from 'app/request-form/_models/attachment.interface';

@Component({
  selector: 'app-multi-download-attachment',
  templateUrl: './multi-download-attachment.component.html',
  styleUrls: ['./multi-download-attachment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MultiDownloadAttachmentComponent {
  @Input() attachments: IAttachment[];
  @Output() clickItem = new EventEmitter<IAttachment>();

  @ViewChild('templateModalAttachments') templateModalAttachments: TemplateRef<any>;
  modal: any;

  constructor(
    private readonly modalService: DSM3ModalService,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  /**
   * Method called when attachment is clicked to download
   * @param attachment attachment clicked from attachment list
   */
  clickAttachment(attachment: IAttachment): void {
    this.clickItem.emit(attachment);
  }

  /**
   * Open modal with attachment list
   */
  openModalAction(): void {
    if (!this.modal) {
      this.modal = this.modalService.custom(this.templateModalAttachments, this.viewContainerRef);

      this.modal.onClose().subscribe(() => {
        this.modal = undefined;
        this.changeDetectorRef.detectChanges();
      });
    }
    this.changeDetectorRef.detectChanges();
  }
}
